var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4661_32170",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#949494"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4661_32170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7756 17.0833H6.52248V7.08334L12.0512 1.58667L12.7562 2.29167C12.8429 2.3782 12.9148 2.49278 12.9719 2.63542C13.0291 2.77806 13.0577 2.91243 13.0577 3.03855V3.25L12.1729 7.08334H17.2435C17.6399 7.08334 17.99 7.23535 18.2939 7.53938C18.598 7.84327 18.75 8.19341 18.75 8.5898V9.93584C18.75 10.0224 18.7409 10.1158 18.7227 10.2163C18.7045 10.3167 18.6773 10.4102 18.641 10.4969L16.2531 16.1315C16.1335 16.3985 15.9332 16.624 15.6523 16.8077C15.3713 16.9915 15.0791 17.0833 14.7756 17.0833ZM5.27248 7.08334V17.0833H2.08331V7.08334H5.27248Z",
    fill: "#949494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLikeIcon);
export default __webpack_public_path__ + "static/media/active-like-icon.6a928159010e1cb905af95734429e7cb.svg";
export { ForwardRef as ReactComponent };